import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Tile } from '../msw.component';

@Component( {
    selector: 'ridango-msw-tile',
    templateUrl: './msw-tile.component.html',
    styleUrls: [ './msw-tile.component.scss' ]
} )
export class MswTileComponent implements OnInit {

    @Input() tile: Tile;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onTileClick = new EventEmitter<any>();

    dead = false;
    constructor() { }

    ngOnInit () {
    }

    click () {
        if ( !this.tile.clicked ) {
            this.onTileClick.emit( this.tile );
            if ( this.tile.value === '*' ) {
                this.dead = true;
            }
        }



    }

}
